<section
  id="digitalisDetails"
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <mprd-digitalis-skeleton *ngIf="!productDetails"></mprd-digitalis-skeleton>
  <main *ngIf="productDetails" id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ 'digitalis.subtitle' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <mprd-manage-your-websites
              [productDetails]="productDetails"
              (selectWebsite)="onSelectWebsite($event)"
            ></mprd-manage-your-websites>
            <mprd-website-options
              [options]="options"
              [selectedProduct]="selectedProduct"
            ></mprd-website-options>
            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-8">
                <mprd-emarketing
                  [options]="options"
                  [selectedProduct]="selectedProduct"
                ></mprd-emarketing>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-manage-your-account></mprd-manage-your-account>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
